var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSortAsc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#A30000",
    width: "100pt",
    height: "100pt",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m27.398 8.6016h6.6992l16 36.898h-9.0977l-3.1992-7.8008h-14.301l-3.1016 7.8008h-9zm3.2031 10.699-4.5 11.5h9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.301 83.398 18.699-22.199h-18v-7.1992h27.898v7.1992l-18.398 22.199h19v7.5h-29.199z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m86.602 64.898h-8.3008v-52.098c0-2.3008-1.8984-4.1992-4.1992-4.1992h-4.5c-2.3008 0-4.1992 1.8984-4.1992 4.1992v52.102h-8.3008c-1.6992 0-2.3984 1.1016-1.5 2.5l14.602 22.5c0.89844 1.3984 2.3984 1.3984 3.3008 0l14.602-22.5c0.89453-1.4023 0.19531-2.5039-1.5039-2.5039z",
    fillRule: "evenodd"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortAsc);
export default __webpack_public_path__ + "static/media/sortAsc.8d113152c8e0023bbb3d007800e257ef.svg";
export { ForwardRef as ReactComponent };